export function shareChatPost(){
/*     console.log('shareChatPost loaded');
    if(!document.querySelector('.js-button-share')) return;
    const shareButtons = document.querySelectorAll('.js-button-share');
    shareButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const post = button.closest('.chat__feed__item');
            const dest = post.getAttribute('data-link') ? post.getAttribute('data-link') : '';
            navigator.clipboard.writeText(dest)      // Remove any existing message element
            const existingMsg = button.querySelector('.chat__feed__item__interact--share-msg');
            if (existingMsg) {
                existingMsg.remove();
            }
            const messageEl = document.createElement('span');
            messageEl.classList.add('chat__feed__item__interact--share-msg');
            messageEl.textContent = 'Link kopieret til udklipsholder';
            button.appendChild(messageEl);

            console.log('Link copied to clipboard:', dest);
            // Remove it after 2.5 seconds
            setTimeout(() => {
                messageEl.remove();
            }, 700);
        });
    }); */

}

export default shareChatPost;